import { render, staticRenderFns } from "./MotionSearchItem.vue?vue&type=template&id=1667cddd&scoped=true&"
import script from "./MotionSearchItem.vue?vue&type=script&lang=ts&"
export * from "./MotionSearchItem.vue?vue&type=script&lang=ts&"
import style0 from "./MotionSearchItem.vue?vue&type=style&index=0&id=1667cddd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1667cddd",
  null
  
)

export default component.exports